import { DEFAULT_CURRENCY, moneyFormat } from "@redotech/money/util";
import { Condition } from "@redotech/redo-return-core-common/return-flow/condition";
import { AdjustmentAmountOption } from "@redotech/redo-return-core-common/return-flow/condition-enums";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import {
  adjustmentAmountFromModel,
  validateAdjustmentAmountCondition,
  type AdjustmentAmountState,
} from "@redotech/redo-return-core-common/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const ADJUSTMENT_AMOUNT = (
  Details: React.ComponentType<
    ConditionTypeDetailsProps<AdjustmentAmountState>
  >,
): ConditionType<AdjustmentAmountState, Condition.AdjustmentAmount> => ({
  name: CONDITION_NAMES[Condition.ADJUSTMENT_AMOUNT],
  description(state) {
    return `Adjustment amount ${state.adjustmentAmountOption.toLowerCase()} ${moneyFormat(
      { amount: +state.adjustmentAmount, currency: DEFAULT_CURRENCY },
    )}`;
  },
  Details(props: ConditionTypeDetailsProps<AdjustmentAmountState>) {
    return React.createElement(Details, props);
  },
  empty: {
    adjustmentAmountOption: AdjustmentAmountOption.EQUALS,
    adjustmentAmount: (0).toFixed(2),
  },
  fromModel(model) {
    return adjustmentAmountFromModel(model);
  },
  toModel(state) {
    return {
      type: Condition.ADJUSTMENT_AMOUNT,
      adjustmentAmountOption: state.adjustmentAmountOption,
      adjustmentAmount: +state.adjustmentAmount,
    };
  },
  valid(state) {
    return validateAdjustmentAmountCondition(state).valid;
  },
});
